<template>
  <div id="ApplicationEventForm">
    <AgreementsInvestorDialog
      @close="isAgreementsInvestorDialogOpen = false"
      v-if="isAgreementsInvestorDialogOpen"
    />
    <ValidationObserver v-slot="{ invalid, errors }" ref="validform">
      <form @submit.prevent="application()">
        <main class="">
          <div class="section top">
            <div class="top__logo">
              <h3><strong>오늘의 식당</strong></h3>
            </div>
          </div>
          <div class="section form-group">
            <div class="promotion">
              <img
                src="../../../assets/images/todaystore/todaystore-temporary-halt.png"
              />
            </div>
            <div class="field-group phone flex">
              <FormInput
                type="tel"
                name="phone"
                style="flex: auto"
                v-model="applicationData.phone"
                rules="required|numeric|phone"
                placeholder="전화번호를 입력해주세요"
              />
              <p
                v-if="errors.phone != null && errors.phone[0] != null"
                class="error-text"
              >
                {{ errors.phone[0] }}
              </p>
            </div>
            <div class="field-group gender">
              <button
                v-ripple
                type="button"
                @click="selectGender('female')"
                name="gender"
                :class="{ selected: applicationData.gender === 'female' }"
              >
                여자
              </button>
              <button
                v-ripple
                type="button"
                @click="selectGender('male')"
                name="gender"
                :class="{ selected: applicationData.gender === 'male' }"
              >
                남자
              </button>
            </div>
            <div class="field-group ageGroup">
              <button
                v-ripple
                type="button"
                @click="selectAgeGruoup(10)"
                name="ageGroup"
                :class="{ selected: applicationData.ageGroup === 10 }"
              >
                10대
              </button>
              <button
                v-ripple
                type="button"
                @click="selectAgeGruoup(20)"
                name="ageGroup"
                :class="{ selected: applicationData.ageGroup === 20 }"
              >
                20대
              </button>
              <button
                v-ripple
                type="button"
                @click="selectAgeGruoup(30)"
                name="ageGroup"
                :class="{ selected: applicationData.ageGroup === 30 }"
              >
                30대
              </button>
              <button
                v-ripple
                type="button"
                @click="selectAgeGruoup(40)"
                name="ageGroup"
                :class="{ selected: applicationData.ageGroup === 40 }"
              >
                40대 이상
              </button>
            </div>
            <div class="field-group active_address flex">
              <FormInput
                @click="openAddress()"
                type="text"
                readonly="readonly"
                name="active_address"
                style="cursor: pointer"
                v-model="applicationData.activeAddress"
                rules="required"
                placeholder="혜택정보를 받고싶은 근처의 주소를 입력해주세요"
              />
              <p
                v-if="
                  errors.activeAddress != null &&
                  errors.activeAddress[0] != null
                "
                class="error-text"
              >
                {{ errors.activeAddress[0] }}
              </p>
            </div>
            <div
              :class="
                daumPostcodeShow == true
                  ? 'daum-post-wrapper-active'
                  : 'daum-post-wrapper'
              "
              id="daumPostcodeWrap"
              style="
                margin: 5px 0;
                position: relative;
                width: 100%;
                height: auto;
              "
            ></div>
            <div class="field-group agree-wrapper">
              <div class="img">
                <img
                  @click="isAgreed = !isAgreed"
                  v-if="isAgreed == true"
                  src="../../../assets/images/etc-checkbox-dn.png"
                />
                <img
                  @click="isAgreed = !isAgreed"
                  v-else
                  src="../../../assets/images/etc-checkbox.png"
                />
              </div>
              <div
                class="agreement"
                @click="isAgreementsInvestorDialogOpen = true"
              >
                <p class="agreement__text">개인정보 이용&#183;제공 동의</p>
              </div>
            </div>
            <div class="sub-description">
              <p class="sub-description__bottom">
                *이벤트를 정상적으로 응모하신 분에 한해 바나나우유 100% 증정 /
                에어팟 프로(2명), 스타벅스 아이스아메리카노(1,000명) 추첨
              </p>
            </div>
          </div>
          <div>
            <button
              type="submit"
              :disabled="invalid || isInProgress"
              class="button complete-button"
            >
              친구 추가하고 응모 완료하기!
              <v-progress-circular
                style="padding-left: 15px"
                size="24"
                v-if="isInProgress"
                indeterminate
                color="primary"
              />
            </button>
          </div>
        </main>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import applicationApi from '@/api/todaystore/applicationApi'
import FormInput from '@/components/form/FormInput'
import ChannelService from '@/service/channeltalk/ChannelService'
import AgreementsInvestorDialog from '@/components/modal/AgreementsInvestorDialog'
import JsUtil from '@/util/JsUtil'

const plusFriendUrl = 'http://pf.kakao.com/_bXfhK'

export default {
  name: 'ApplicationEventForm',
  components: {
    FormInput,
    AgreementsInvestorDialog,
  },
  data() {
    return {
      applicationData: {
        phone: null,
        gender: 'female',
        ageGroup: 20,
        activeAddress: null,
      },
      daumPostcodeShow: false,
      isDaumPostcodeInitialize: false,
      isAgreed: false,
      isAgreementsInvestorDialogOpen: false,
      isInProgress: false,
    }
  },
  async created() {
    document.title = '오늘의 식당'
  },
  mounted() {
    ChannelService.shutdown()
  },
  methods: {
    selectGender(select) {
      this.applicationData.gender = select
    },
    selectAgeGruoup(select) {
      this.applicationData.ageGroup = select
    },
    async application() {
      if (this.isAgreed === false) {
        alert('"경품 응모를 위한 개인정보 이용 제공 동의" 항목을 선택해주세요.')
        return
      }
      if (
        this.isInProgress === true ||
        this.$refs.validform.flags.invalid === true
      ) {
        return
      }
      this.isInProgress = true
      try {
        const formData = new FormData()
        formData.append('phone', this.applicationData.phone)
        formData.append('active_address', this.applicationData.activeAddress)
        formData.append('gender', this.applicationData.gender)
        formData.append('age_group', this.applicationData.ageGroup)
        await applicationApi.postApplication(formData)
        alert('정상적으로 응모되었습니다. 감사합니다.')
        window.location = plusFriendUrl
      } catch (e) {
        alert('응모하는데 문제가 발생했습니다.')
      } finally {
        this.isInProgress = false
      }
    },
    openAddress() {
      if (this.daumPostcodeShow === true) {
        return
      } else if (this.isDaumPostcodeInitialize === true) {
        this.daumPostcodeShow = true
        return
      }
      let elementWrap = document.getElementById('daumPostcodeWrap')
      JsUtil.loadasync({
        id: 'daumPostcode',
        src:
          '//spi.maps.daum.net/imap/map_js_init/postcode.v2.js?autoload=false',
      }).then((_) => {
        this.isDaumPostcodeInitialize = true
        window.daum.postcode.load((_) => {
          new window.daum.Postcode({
            oncomplete: (data) => {
              let addr = ''
              if (data.userSelectedType === 'R') {
                addr = data.roadAddress
              } else {
                addr = data.jibunAddress
              }
              this.applicationData.activeAddress = addr

              this.daumPostcodeShow = false
              this.isDaumPostcodeInitialize = false
            },
            onresize: function (size) {
              elementWrap.style.height = 'auto'
            },
            width: '100%',
          }).embed(elementWrap)

          this.daumPostcodeShow = true
        })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
#ApplicationEventForm {
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-weight: 300;
  }
  .section {
    padding-left: 0;
    padding-right: 0;
  }
  .section.form-group {
    .field-group {
      padding-left: 3.2%;
      padding-right: 3.2%;
    }
    .field-group.phone {
      margin-top: 2.2%;
    }
    h3.title {
      text-align: center;
    }
    .promotion img {
      max-width: 100%;
    }
    .gender {
      flex-direction: row;
    }
    .gender button {
      border-radius: 4px;
      width: 100%;
      border-color: #d7e1ea;
      background-color: #d7e1ea;
      color: #727d8c;
      height: 48px;
      font-size: 18px;
      font-weight: 600;
    }
    .gender button:last-child {
      margin-left: 2.77%;
    }
    .gender button.selected,
    .ageGroup button.selected {
      border-color: #352921;
      background-color: #352921;
      color: #ffffff;
    }
    .ageGroup button {
      width: 100%;
      border-color: #d7e1ea;
      background-color: #d7e1ea;
      color: #727d8c;
      height: 48px;
      font-size: 86%;
      font-weight: 600;
      padding: 0;
    }
    .ageGroup button:first-child {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    .ageGroup button:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
    .agree-wrapper {
      display: flex;
      margin-top: 20px;
    }
    .agree-wrapper img {
      position: relative;
      bottom: 4px;
    }
    .agreement {
      margin-left: 1%;
    }
    .agreement__text {
      text-decoration: underline;
    }
    input[data-v-3241fe4b]:read-only {
      background-color: #ffffff !important;
    }
    .sub-description {
      padding-left: 3.2%;
      padding-right: 3.2%;
    }
    .sub-description__bottom {
      font-size: 15px;
      margin: 3% 0;
      color: #333333;
      font-weight: 600;
    }
  }
  .top__logo {
    background-color: #352921;
    min-height: 50px;
    width: 100%;
    display: table;
    h3 {
      color: white;
      text-align: center;
      display: table-cell;
      vertical-align: middle;
    }
  }
  .button.button {
    z-index: 0 !important;
    position: relative !important;
    min-height: 60px !important;
    font-weight: 700 !important;
  }
  button.complete-button:disabled {
    background-color: #e1e9f3 !important;
    color: #9aa4b3 !important;
  }
  button.complete-button {
    background-color: #ffe500 !important;
    color: #352921 !important;
  }
}
</style>
